import { render } from "./ArticleListBlock.vue?vue&type=template&id=06ecb83e"
import script from "./ArticleListBlock.vue?vue&type=script&lang=js"
export * from "./ArticleListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__